import { useLanguage } from '../../../../../contexts/LanguageContext';

export function useWheelLocale(): string {
  const { language } = useLanguage();
  if (language === 'ja') return 'ja-JP';
  if (language === 'vi') return 'vi-VN';
  return 'en-US';
}
